const displayMethods = [
  {
    name: 'Table',
    value: 'table',
    translationKey: {
      id: 'ui-reports.displayMethods.table',
      defaultMessage: 'Table'
    },
    settings: {
      columnWidths: {},
      columnMapping: {},
      visibleColumns: [],
      translatableFields: [{ fieldName: '', keyPattern: '' }]
    }
  },
  {
    name: 'Pivot Table',
    value: 'pivotTable',
    translationKey: {
      id: 'ui-reports.displayMethods.pivotTable',
      defaultMessage: 'Pivot Table'
    },
    settings: {}
  },
  {
    name: 'Grouped View',
    value: 'groupedView',
    translationKey: {
      id: 'ui-reports.displayMethods.groupedView',
      defaultMessage: 'Grouped View'
    },
    settings: {}
  },
  {
    name: 'Bar Chart',
    value: 'barChart',
    translationKey: {
      id: 'ui-reports.displayMethods.barChart',
      defaultMessage: 'Bar Chart'
    },
    settings: {}
  },
  {
    name: 'Pie Chart',
    value: 'pieChart',
    translationKey: {
      id: 'ui-reports.displayMethods.pieChart',
      defaultMessage: 'Pie Chart'
    },
    settings: {}
  },
  {
    name: 'Line Chart',
    value: 'lineChart',
    translationKey: {
      id: 'ui-reports.displayMethods.lineChart',
      defaultMessage: 'Line Chart'
    },
    settings: {}
  },
  {
    name: 'Area Chart',
    value: 'areaChart',
    translationKey: {
      id: 'ui-reports.displayMethods.areaChart',
      defaultMessage: 'Area Chart'
    },
    settings: {}
  },
  {
    name: 'Numeric Label',
    value: 'numLabel',
    translationKey: {
      id: 'ui-reports.displayMethods.numLabel',
      defaultMessage: 'Numeric Label'
    },
    settings: {}
  },
];

export default displayMethods;
